module.exports = __webpack_public_path__ + "img/main_punic_map.f86160e5.png";